import { render } from "./TherapyPage.vue?vue&type=template&id=2709927f&scoped=true"
import script from "./TherapyPage.vue?vue&type=script&lang=js"
export * from "./TherapyPage.vue?vue&type=script&lang=js"

import "./TherapyPage.vue?vue&type=style&index=0&id=2709927f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2709927f"]])

export default __exports__